export function createEmailNotification(email, variantId, productId, options = {}) {
    return new Promise((resolve, reject) => {
        if (window.BIS) {
            window.BIS.create(email, variantId, productId, options).then((response) => {
                if (response.errors) {
                    Object.values(response.errors).forEach((err) => {
                        console.error(`BIS error: ${err}`);
                    });
                    reject(response.errors);
                }
                else {
                    resolve();
                }
            });
        }
        else {
            console.warn('window.BIS not defined; unable to create email notification');
            reject();
        }
    });
}
